import { ApiError } from "@/lib/api";

export const EXPLAIN_OPERATION_KEY_PATTERN =
  /^pgex_[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

const NEW_OPERATION_AFTER_ERROR_CODES = new Set([
  "AI_ERROR",
  "AI_UNAVAILABLE",
  "AI_GENERATION_PRIOR_FAILED",
  "AI_REPLAY_RESULT_UNAVAILABLE",
]);

export function createExplainOperationKey(): string {
  return `pgex_${crypto.randomUUID()}`;
}

/** One automatic retry for transport failures; API responses are authoritative. */
export function shouldRetryExplainMutation(failureCount: number, error: unknown): boolean {
  return !(error instanceof ApiError) && failureCount < 1;
}

/**
 * Explicit retry keeps the same key unless the backend confirms the prior
 * operation failed/refunded and a new deliberate operation is required.
 */
export function shouldReuseExplainOperationKey(error: unknown): boolean {
  return !(
    error instanceof ApiError &&
    error.code !== undefined &&
    NEW_OPERATION_AFTER_ERROR_CODES.has(error.code)
  );
}
